import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Spinner from '../../../components/ui/Spinner';
import { clinicalDelegationService, type PendingSignature } from '../../../services/clinicalDelegationService';

/**
 * clinical-record-signing R7: the doctor's own open drafts and drafts
 * recorded by assistants share one queue, oldest first, with each draft's
 * age. Only rendered for a doctor (the endpoint 403s everyone else).
 */
const PendingSignaturesCard: React.FC = () => {
  const [items, setItems] = useState<PendingSignature[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    clinicalDelegationService.getPendingSignatures()
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title d-inline-block">Pendientes de Firma</h4>
      </div>
      <div className="card-body p-0 table-dash">
        <div className="table-responsive">
          <table className="table mb-0 border-0 custom-table">
            <thead>
              <tr>
                <th>Consulta</th>
                <th>Registrado por</th>
                <th>Antigüedad</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={4} className="text-center py-3"><Spinner /></td></tr>
              ) : items.length === 0 ? (
                <tr><td colSpan={4} className="text-center text-muted py-3">No hay consultas pendientes de firma</td></tr>
              ) : (
                items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.consultation_number || `#${item.id}`}</td>
                    <td className="text-muted">{item.is_own ? 'Usted' : (item.recorded_by_name || '—')}</td>
                    <td>{Math.round(item.age_hours)}h</td>
                    <td>
                      <Link to={`/consultations/${item.id}/review`} className="btn btn-sm btn-outline-primary">
                        Revisar
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PendingSignaturesCard;
